export default "__VITE_ASSET__28315dda__"